import { ApiConnection } from 'config'

const getProductsSections = async (cardCode) => {
  const { data } = await ApiConnection.get('cms-products-section', { params: { cardCode } })
  return data.response
}

export default getProductsSections
